//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import Table from "@/components/FilterTable/Table.vue";

const DEFAULT_FORMAT = (value) => (value ? value : "N/A");

export default {
  name: "TraitsTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table,
  },
  mounted: function () {
    BackendServices.getProductHierarchyLevels().then((response) => {
      let hierarchyColumns = response.data.map((level, index) => {
        return {
          name: level.name.toLowerCase().replace(" ", "-"),
          required: false,
          label: level.name,
          align: "left",
          field: (row) =>
            row.hierarchy[index] ? row.hierarchy[index].name : "N/A",
          format: DEFAULT_FORMAT,
          sortable: false,
        };
      });
      this.columns = [
        {
          name: "ean",
          required: false,
          label: "EAN",
          align: "left",
          field: (row) => row.ean,
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "name",
          required: false,
          align: "left",
          label: "Nome",
          field: (row) => row.name,
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        ...hierarchyColumns,
        {
          name: "external-code",
          required: false,
          align: "left",
          label: "ID Externo",
          field: (row) => row.external_id,
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "sales-volume-factor",
          required: false,
          align: "left",
          label: "Factor Vendas Volume",
          field: (row) => row.sales_volume_factor,
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "table-price",
          required: false,
          align: "left",
          label: "Preço de tabela (€)",
          field: (row) => row.price,
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "pvp",
          required: false,
          align: "left",
          label: "PVP Rec.",
          field: (row) => row.recommended_pvp,
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "iva",
          required: false,
          align: "left",
          label: "IVA",
          field: (row) => row.iva,
          format: (value) => (value ? `${value} %` : "N/A"),
          sortable: false,
        },
        {
          name: "iec",
          required: false,
          align: "left",
          label: "IEC",
          field: (row) => row.iec,
          format: DEFAULT_FORMAT,
          sortable: false,
        },
        {
          name: "links",
          required: false,
          align: "left",
          label: "Links",
          field: (row) => row.links,
          format: DEFAULT_FORMAT,
          sortable: false,
        },
      ];
    });
  },
  data: () => ({
    separator: "horizontal",
    columns: [],
    filteredData: [],
  }),
  methods: {
    renderRightSide: function (event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function (event) {
      this.$emit("filter-changed", event);
    },
    updateSearch(search) {
      this.$emit("search-changed", search);
    },
  },
};
